import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Footer.css';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-brand">
          <img src={logo} alt="Hangrily" className="footer-logo-image" />
          <span className="footer-tagline">Stop arguing. Start eating.</span>
        </div>
        <div className="footer-links">
          <button onClick={() => navigate('/')} className="footer-link">Home</button>
          <button onClick={() => navigate('/about')} className="footer-link">About</button>
          <button onClick={() => navigate('/privacy')} className="footer-link">Privacy</button>
          <button onClick={() => navigate('/terms')} className="footer-link">Terms</button>
          <button onClick={() => navigate('/contact')} className="footer-link">Contact</button>
        </div>
        <div className="footer-copy">
          <span>© 2026 Hangrily • support@hangrily.app</span>
        </div>
      </div>
    </footer>
  );
}
